import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SearchableAutocompleteComponent } from './searchable-autocomplete.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule
  ],
  declarations: [SearchableAutocompleteComponent],
  exports: [SearchableAutocompleteComponent]
})
export class SearchableAutocompleteModule { }
